import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TogglesConfiguration } from "../../core/enum/toggles-configuration.enum";
import { LocalStorage } from "../../core/helpers/local-storage";
import { TogglesValidation } from "../../core/helpers/toggles";
import { AuthenticationService } from "../../core/services/auth.service";
import { take, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import Swal from "sweetalert2";

import { ToggleMenuService } from "src/app/core/services/toggle-menu.service";
import { ApiServiceShared } from "../../core/services/shared.service";
import { ApiServiceNotifications } from "src/app/core/services/notifications.service";
import { Notification } from "../../core/interfaces/notifications.interface";
import { RolesLabelEnum, RolesUsersEnum } from "../../core/enum/roles-users.enum";
import { NewProposeDialog } from "../../shared/components/dialogs/new-propose-dialog/new-propose-dialog.component";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"]
})
export class TopBarComponent implements OnInit {
  notificationItems: Notification[];
  user = LocalStorage.getItem("currentUser");
  dropdown: boolean = false;
  rolesLabelEnum = RolesLabelEnum;

  hiddenBadge: boolean = false;
  subscription: any;
  statusShowAllNotifications: boolean = false;
  notificationsList$: Observable<any>;
  numberOfNotifications: number = 0;

  innerWidth: number;
  @ViewChild("labelStore")
  labelStore: ElementRef<HTMLDivElement>;
  @ViewChild("labelProposal")
  labelProposal: ElementRef<HTMLDivElement>;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private apiServiceShared: ApiServiceShared,
    private toggleMenuService: ToggleMenuService,
    private apiServiceNotifications: ApiServiceNotifications,
    private dialog: MatDialog
  ) {
    // this.user = LocalStorage.getItem('currentUser').user;
  }

  ngOnInit() {
    // get the notifications
    this._fetchNotifications();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.apiServiceShared
      .updateLocalStorage()
      .pipe(take(1))
      .subscribe(status => {});

    this.getNotifications();

    if (!this.numberOfNotifications) this.hiddenBadge = true;
  }

  dropDown() {
    this.dropdown = !this.dropdown;
  }

  alert(title: string, icon: any) {
    Swal.fire({
      type: icon,
      title: title,
      showConfirmButton: false,
      timer: 1500
    });
  }

  get roles() {
    return this.user.roles;
  }

  get isAdmin() {
    return this.roles === "ADMINISTRADOR";
  }

  onToggleMobileMenu() {
    this.toggleMenuService.toggle();
  }

  hasNotification = null;

  getNotifications() {
    this.notificationsList$ = this.apiServiceNotifications.getAllNotifications().pipe(
      tap(res => {
        let quantityItemsIsRead: any = 0;

        quantityItemsIsRead = res.Items.filter(item => {
          return item.is_read == 0;
        });

        this.numberOfNotifications = quantityItemsIsRead.length;

        this.numberOfNotifications = this.numberOfNotifications < 99 ? this.numberOfNotifications : 99;
        this.hiddenBadge = this.numberOfNotifications > 0 ? false : true;
      })
    );

    this.notificationsList$.subscribe({
      error: () => {
        this.hasNotification = false;
      }
    });
  }

  clickNotifications() {
    this.toggleBadgeVisibility();
    this.showAllNotificationsFalse();
  }

  showAllNotifications() {
    this.statusShowAllNotifications = true;
  }

  showAllNotificationsFalse() {
    this.statusShowAllNotifications = false;
  }

  toggleBadgeVisibility() {
    this.hiddenBadge = true;
  }

  deleteNotification(id: string) {
    this.apiServiceNotifications.deleteNotifications(id).subscribe(
      res => {
        this.alert("Notificação deletada com sucesso", "success");
        this.getNotifications();
      },
      error => {
        this.alert("Ocorreu um erro ao deletar notificação", "error");
        throw Error(error.message);
      }
    );
  }

  setReadAndRedirect(id: string, idCard: string, isRead: boolean) {
    if (!isRead) {
      this.apiServiceNotifications.updateStatusNotifications(id).subscribe({
        next: res => {
          this.getNotifications();
        },
        error: error => {
          throw Error(error.message);
        }
      });
    }

    this.router.navigate([`kanban-bitrix`], {
      onSameUrlNavigation: "reload",
      queryParams: { idcard: idCard },
      queryParamsHandling: "merge"
    });
  }

  get nameCircle() {
    if (this.user && this.user.name.split(" ").length === 1) {
      return this.user.name.split(" ")[0].substring(0, 1).toUpperCase();
    }

    if (this.user && this.user.name.split(" ").length > 1) {
      return (
        this.user.name.split(" ")[0].substring(0, 1).toUpperCase() +
        " " +
        this.user.name.split(" ")[1].substring(0, 1).toUpperCase()
      );
    }
  }

  addActive(whichButton) {
    if (whichButton === "store") {
      this.labelStore.nativeElement.classList.add("activeStore");
    }

    if (whichButton === "newProposal") {
      this.labelProposal.nativeElement.classList.add("activeProposal");
    }
  }

  removeActive(whichButton) {
    if (whichButton === "store") {
      this.labelStore.nativeElement.classList.remove("activeStore");
    }

    if (whichButton === "newProposal") {
      this.labelProposal.nativeElement.classList.remove("activeProposal");
    }
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]);
    location.reload();
  }

  /**
   * Fetches the notification
   * Note: For now returns the hard coded notifications
   */
  _fetchNotifications() {
    this.notificationItems = [];
  }

  openStore() {
    this.router.navigate([]).then(result => {
      window.open(`${window.location.origin}/#/store/${this.user.store.slug}`, "_blank");
    });
  }

  openPageHelper() {
    if (this.isAdmin) {
      this.router.navigate(["faq-adm/list"]);
    } else {
      this.router.navigate(["/faq"]);
    }
  }

  modalNewPropose() {
    this.dialog.open(NewProposeDialog, {
      width: "400px"
    });
  }

  autoCloseForDropdown(event) {
    if (this.dropdown && event.srcElement.parentElement.className.indexOf("dropdown") === -1) {
      this.dropdown = false;
    }
  }

  visibleUser() {
    if (this.user.roles === RolesUsersEnum.ADMIN) {
      return TogglesValidation.toggleShow(TogglesConfiguration.FAQ_ADMIN);
    }

    return TogglesValidation.toggleShow(TogglesConfiguration.FAQ_MANAGER);
  }
}
